import { styled, Tooltip as MuiTooltip } from "@mui/material";

// Styled tooltip
const StyledTooltip = styled(({ className, ...props }) => <MuiTooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: "#fff",
      color: "#555",
      fontSize: "0.85rem",
      fontWeight: 500,
      borderRadius: 8,
      padding: "8px 12px",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
    },
    [`& .MuiTooltip-arrow`]: {
      color: "#fff",
      "&::before": {
        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)", // match tooltip shadow
      },
    },
  }),
);

export const CustomTooltip = ({ title, children, ...props }) => {
  return (
    <StyledTooltip
      title={title}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, -5] }, // negative offset moves tooltip closer
          },
          {
            name: "preventOverflow",
            options: { altAxis: true },
          },
        ],
      }}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};
